import { PageBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';

const customHomePage = PageBlueprint.make({
  name: 'home',
  params: {
    path: '/home',
    title: 'Home',
    loader: () =>
      import('../../components/home/HomePage').then(m => <m.HomePage />),
  },
});

export const homePageModule = createFrontendModule({
  pluginId: 'home',
  extensions: [customHomePage],
});
